import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { nullable } from '$lib/propTypes';

class Seo extends Component {
  render() {
    const { title, description, canonical, robots } = this.props;

    return (
      <Helmet title={title}>
        {description && <meta name="description" content={description} />}
        {canonical && (
          <link rel="canonical" href={`https://app.achievable.me${canonical}`} />
        )}
        <meta name="robots" content={robots} />
      </Helmet>
    );
  }
}

Seo.propTypes = {
  canonical: nullable(PropTypes.string),
  description: nullable(PropTypes.string),
  robots: PropTypes.string,
  title: PropTypes.string,
};

Seo.defaultProps = {
  robots: 'all',
};

export default Seo;
